import React, { useEffect, useState } from 'react';
import { Input } from '../ui/input';

export const DraftNumber = ({ value, onCommit, ...props }) => {
  const [draft, setDraft] = useState(String(value)), [focused, setFocused] = useState(false);
  useEffect(() => { if (!focused) setDraft(String(value)); }, [value, focused]);
  return <Input {...props} type="number" inputMode="decimal" value={draft} onFocus={() => setFocused(true)} onChange={(event) => setDraft(event.target.value)} onBlur={() => { if (draft !== '' && Number.isFinite(Number(draft))) onCommit(Number(draft)); setFocused(false); }} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); event.currentTarget.blur(); } }} />;
};